import { Image } from '@chakra-ui/react';
import { getContractAddress } from '@cronos-app/sdk';

import type { TokenRegister } from '../types';
import { Token } from '../types';

export const getAgentFunToken: TokenRegister = (desiredNetwork) => {
  return {
    type: Token.agentFun,
    symbol: 'AGENTFUN',
    address: getContractAddress(desiredNetwork, 'AgentFun'),
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src="/tokens/agentfun.svg"
        boxSize="24px"
        alt="Agent Fun"
        {...props}
        // border-radius would clip AgentFun icon
        rounded="0"
      />
    ),
  };
};
